import SearchPlaces from "components/shared/Map/SearchPlace";
import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Form } from "react-bootstrap";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { useDispatch } from "react-redux";
import { GET_DEFAULT_ADDRESS } from "store/Action/HomeAction";
import { formatter } from "utils/constants/Constants";
import "../orderFromYourFavoritResturant/styled.css";
import "../orderFromYourFavoritResturant/ordermedia.css";
import LottiLoader from "components/shared/Loader/LottiLoader";
import { useNavigate } from "react-router-dom";
import OrderSearchMobile from "./OrderSearchMobile";

const OrderFromYourFavResturant = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //ALL STATE
  const [address, setAddress] = useState("");
  const [emptySeacrh, setEmptySearch] = useState(false);
  const [orderSearch, setOrderSearch] = useState(false);
  const searchInput = useRef(null);

  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const handleSelectLocation = () => {
    setOrderSearch(!orderSearch);
    setAddress("");
    if (windowSize[0] < 768) {
      searchInput.current.blur();
    }
  };
  const handleChange = (event) => {
    setAddress(event.replace(/^\s+/g, ""));
  };

  const intialRender = useRef(true);
  useEffect(() => {
    if (intialRender.current) {
      intialRender.current = false;
    } else {
      if (address) {
        setEmptySearch(false);
      } else {
        setEmptySearch(true);
      }
    }
  }, [address]);

  const handleSelect = (address) => {
    geocodeByAddress(address)
      .then(async (results) => {
        const x = formatter({ results: results });
        const {
          address,
          city,
          state,
          country,
          postal_code,
          street_number,
          route,
        } = x;
        let latlong = await getLatLng(results[0]);
        // console.log("results", results[0]?.place_id);
        return {
          latlong: latlong,
          address: results[0].formatted_address,
          entry_street_address: address,
          entry_postcode: postal_code,
          entry_suburb:
            street_number && route
              ? street_number.concat(`, ${route}`)
              : street_number
              ? street_number
              : route
              ? route
              : "",
          entry_state: state,
          entry_city: city,
          google_place_id: results[0]?.place_id,
        };
      })
      .then((latlong) => {
        const {
          entry_street_address,
          entry_postcode,
          entry_suburb,
          entry_state,
          entry_city,
          google_place_id,
        } = latlong;

        setAddress(entry_street_address);

        dispatch(
          GET_DEFAULT_ADDRESS({
            address_lat: latlong.latlong.lat,
            address_lng: latlong.latlong.lng,
            entry_street_address,
            entry_street_name: entry_suburb,
            entry_postcode,
            entry_suburb,
            entry_state,
            entry_city,
            google_place_id,
          })
        );
        navigate("/restaurants");
      })

      .catch((error) => console.error("Error", error));
  };

  const handelFindFood = () => {
    if (!address) {
      setEmptySearch(true);
    }
    if (address.length > 3) {
      handleSelect(address + " ");
    }
  };

  // Add an import if you installed from npm

  // Register visitor's browser for push notifications

  return (
    <div>
      <section className="banner-sec d-flex align-items-center">
        <Container>
          <div className="content-wrapper">
            <div className="content">
              <h1 className="mb-lg-5 mb-4">
                Order from your favorite local restaurants
              </h1>

              {/* <LocationPermission /> */}
            </div>
            <div className="banner-input-sec position-relative">
              <SearchPlaces
                address={address}
                handleChange={handleChange}
                handleSelect={handleSelect}
                value={address}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading,
                }) => (
                  <div>
                    <Form className="position-relative">
                      <Form.Control
                        {...getInputProps({
                          placeholder: "Search Places ...",
                          className: "location-search-input",
                        })}
                        type="text"
                        placeholder="Enter your address"
                        onClick={() => handleSelectLocation()}
                        ref={searchInput}
                      />
                      <Button
                        type="button"
                        className="position-absolute end-0 top-0 bottom-0 search-btn"
                        onClick={() => handelFindFood()}
                      >
                        Find Food
                      </Button>
                    </Form>
                    <div className="loder-search position-absolute start-0 end-0 text-center mt-4">
                      {loading && (
                        <div>
                          <LottiLoader loader={true} />
                        </div>
                      )}
                    </div>
                    {!loading && suggestions?.length !== 0 && (
                      <div className="autocomplete-dropdown-container restaurants-mobile-view">
                        {suggestions.map((suggestion, index) => {
                          const className = suggestion.active
                            ? "suggestion-item--active"
                            : "suggestion-item";
                          const style = suggestion.active
                            ? { backgroundColor: "#fafafa", cursor: "pointer" }
                            : { backgroundColor: "#ffffff", cursor: "pointer" };
                          return (
                            <div
                              {...getSuggestionItemProps(suggestion, {
                                className,
                                style,
                              })}
                              key={index}
                            >
                              <span>
                                {suggestion?.description
                                  ?.replace(",", "")
                                  ?.replace(",", "")
                                  ?.replace(", USA", "")}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
              </SearchPlaces>
              {/* <Form className="position-relative">
                <Form.Control
                  type="text"
                  placeholder="Enter your address"
                />

                <Button className="position-absolute end-0 top-0 bottom-0 search-btn">
                  Fine Food
                </Button>
              </Form> */}
            </div>
          </div>
        </Container>
        <div>
          {orderSearch && (
            <OrderSearchMobile handleOrder={handleSelectLocation} />
          )}
        </div>
      </section>
    </div>
  );
};

export default OrderFromYourFavResturant;
